export default "__VITE_ASSET__BuYe61am__"